import { useState } from "react";
import { Card } from '@mui/material';
import { Box, Button, Modal, ToggleButton, ToggleButtonGroup } from "@mui/material";
import api from "../../../../services/api";
import MessageSuccess from "../../../../messages/messageSuccess";
import MessageError from "../../../../messages/messageError";
import { useDispatch, useSelector } from "react-redux";
import HeaderGestorConfigs from "../../../../utils/headerGestorConfigs";
import ButtonLeft from "../../../../utils/buttonLeft";
// import FazerObservacoes from "../../../components/fazerObservacoes.";
import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Radio, Typography, Chip } from '@mui/material';

const questions = [
    { _id: 1, text: 'Existem estudos prévios sobre essa reacção?', points: { sim: 1, nao: 0, naoSabe: 0 } },
    { _id: 2, text: 'A reacção adversa ocorreu após administração do medicamento?', points: { sim: 2, nao: -1, naoSabe: 0 } },
    { _id: 3, text: 'O paciente melhora quando o medicamento é retirado ou quando se administra um antagonista específico?', points: { sim: 1, nao: 0, naoSabe: 0 } },
    { _id: 4, text: 'A reacção reaparece quando se readministra o medicamento?', points: { sim: 2, nao: -1, naoSabe: 0 } },
    { _id: 5, text: 'Excluindo o uso de medicamentos, existem outras causas capazes de determinar o surgimento da reacção?', points: { sim: -1, nao: 2, naoSabe: 0 } },
    { _id: 6, text: 'A reacção reaparece ao se administrar placebo?', points: { sim: -1, nao: 1, naoSabe: 0 } },
    { _id: 7, text: 'O medicamento foi detectado em sangue ou outros líquidos orgânicos em concentrações tóxicas?', points: { sim: 1, nao: 0, naoSabe: 0 } },
    { _id: 8, text: 'A reacção foi mais intensa quando se aumentou a dose ou menos intensa quando a dose foi reduzida?', points: { sim: 1, nao: 0, naoSabe: 0 } },
    { _id: 9, text: 'O paciente já apresentou alguma reacção semelhante ao mesmo medicamento ou outro similar?', points: { sim: 1, nao: 0, naoSabe: 0 } },
    { _id: 10, text: 'A reacção adversa foi confirmada por meio de alguma evidência objectiva?', points: { sim: 1, nao: 0, naoSabe: 0 } }
];

const getClassification = (score) => {
    if (score >= 9) return { label: 'Definida (provada)', color: 'success' };
    if (score >= 5) return { label: 'Provável', color: 'info' };
    if (score >= 1) return { label: 'Possível', color: 'warning' };
    return { label: 'Duvidosa', color: 'error' };
};

const formatPoints = (value) =>
    value > 0 ? `+${value}` : value;

const toggleStyle = (points) => ({
    border: 'none',
    borderRadius: 1,
    minWidth: 56,
    fontWeight: 'bold',
    fontSize: 14,

    backgroundColor:
        points > 0 ? '#e8f5e9' :
            points < 0 ? '#fdecea' :
                '#f5f5f5',

    color:
        points > 0 ? '#1b5e20' :
            points < 0 ? '#b71c1c' :
                '#424242',

    '&.Mui-selected': {
        backgroundColor:
            points > 0 ? '#c8e6c9' :
                points < 0 ? '#f5c6cb' :
                    '#e0e0e0',
    },

    '&:hover': {
        backgroundColor:
            points > 0 ? '#dcedc8' :
                points < 0 ? '#f8d7da' :
                    '#eeeeee',
    }
});

export default function AnaliseNarranjo({ idNotificacao }) {
    // const { id } = useParams()
    const dispatch = useDispatch()
    const [relatorio, setrelatorio] = useState()
    const [messageSuccess, setMessageSuccess] = useState('')
    const [messageError, setMessageError] = useState('')
    const [open, setOpen] = useState(false);
    const [openModal, setOpenModal] = useState(false);
    const [obs, setObs] = useState('')
    const user = useSelector(state => state.account.user);
    const [answers, setAnswers] = useState({});

    // function HandleChange(e) {
    //     setrelatorio((prev) => ({ ...prev, [e.target.name]: e.target.value }));
    // }

    const handleChange = (id, option, points) => {
        setAnswers(prev => ({
            ...prev,
            [id]: { option, points }
        }));
    };

    const totalPoints = Object.values(answers)
        .reduce((sum, item) => sum + (item?.points || 0), 0);

    const classification = getClassification(totalPoints)

    const submitRelatorio = async () => {

        setOpen(true)
        setMessageSuccess('')
        setMessageError('')
        // console.log(relatorio)

        await api.patch('/avalicao-analitica/emit-relatorio', {
            ...relatorio,
            comentariosConclusoes: obs,
            // avaliacaoAnaliticaId: avaliacaoAnalitica?._id,
            userId: user?._id
        })
            .then(res => {
                setMessageSuccess(res.data.msg)
                setOpenModal(false)
                // navigate(-1);
                dispatch({
                    type: 'alert',
                    payload: { alert: 'Relatório Analítico emitido com sucesso!' },
                });

            }).catch(err => {
                setMessageError(err.response.data.message)
            }).finally(() => setOpen(false))
    }

    const handleSubmitCausalidade = async () => {
        try {
            setOpen(true);

            const payload = {
                farmacoVigilanciaId: idNotificacao,
                pontuacao: totalPoints,
                tipoReaccao: classification.label,
                avaliacaoCasualidade: obs,
                userId: user?._id
            };

            questions.forEach((q, index) => {
                payload[`pergunta${index + 1}`] = answers[q._id]?.points ?? 0;
            });

            const res = await api.patch(
                '/farmaco-vigilancia/add-casualidade-ram',
                payload
            );

            setMessageSuccess(res.data.msg);
            setOpenModal(false);

            dispatch({
                type: 'alert',
                payload: { alert: 'Avaliação de causalidade efectuada!' },
            });

        } catch (err) {
            setMessageError(err?.response?.data?.message || 'Erro ao salvar avaliação');
        } finally {
            setOpen(false);
            setAnswers({});
        }
    };


    return (
        <>
            <Button
                // disabled={(produtoId && !temPermissao(user, ['controleQualidadeRelatorioAnalitico']))}
                fullWidth
                size="small"
                color="success"
                variant={"outlined"}
                onClick={() => setOpenModal(!openModal)}
            >
                Analise do Narranjo
            </Button>

            <Modal
                open={openModal}
                // onClose={() => setOpenModal(false)}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
                // scroll={'body'}
                sx={{ margin: 2, overflowY: "auto" }}
            >
                <Card style={{ padding: 25, maxWidth: 800, margin: 'auto' }}>
                    {messageSuccess && <MessageSuccess message={messageSuccess} />}
                    {messageError && <MessageError message={messageError} />}

                    <HeaderGestorConfigs title={'Causalidade de RAM de acordo com o Algoritimo de Naranjo e Colab'} />

                    <div style={{ padding: 3 }}>
                        <TableContainer>
                            <Table size="small">
                                <TableHead>
                                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                        <TableCell><strong>Perguntas</strong></TableCell>
                                        <TableCell align="center"><strong>Sim</strong></TableCell>
                                        <TableCell align="center"><strong>Não</strong></TableCell>
                                        <TableCell align="center"><Typography noWrap fontWeight="bold">Não sabe</Typography></TableCell>
                                        <TableCell align="center"><Typography noWrap fontWeight="bold">Pontos</Typography></TableCell>
                                    </TableRow>
                                </TableHead>

                                <TableBody>
                                    {questions.map((q, index) => (
                                        <TableRow key={q._id}>
                                            <TableCell>{index + 1}. {q.text}</TableCell>

                                            {/* {['sim', 'nao', 'naoSabe'].map(opt => (
                                                <TableCell align="center" key={opt}>
                                                    <Radio
                                                        checked={answers[q._id]?.option === opt}
                                                        onChange={() => handleChange(q._id, opt, q.points[opt])}
                                                        color="primary"
                                                    />
                                                </TableCell>
                                            ))} */}

                                            {['sim', 'nao', 'naoSabe'].map(opt => (
                                                <TableCell align="center" key={opt}>
                                                    <ToggleButtonGroup
                                                        exclusive
                                                        value={answers[q._id]?.option || null}
                                                        onChange={(e, newOption) => {
                                                            if (!newOption) return;
                                                            handleChange(q._id, newOption, q.points[newOption]);
                                                        }}
                                                    >
                                                        <ToggleButton
                                                            value={opt}
                                                            sx={toggleStyle(q.points[opt])}
                                                        >
                                                            {formatPoints(q.points[opt])}
                                                        </ToggleButton>
                                                    </ToggleButtonGroup>
                                                </TableCell>
                                            ))}

                                            <TableCell align="center">
                                                <div style={{
                                                    fontWeight: 'bold',
                                                    border: 'none',
                                                    borderRadius: 4,
                                                    minWidth: 56,
                                                    fontSize: 14,
                                                    padding: '12px 16px',
                                                    backgroundColor:
                                                        (answers[q._id]?.points ?? 0) > 0 ? '#c8e6c9' :
                                                            (answers[q._id]?.points ?? 0) < 0 ? '#f5c6cb' :
                                                                '#e0e0e0',
                                                    color:
                                                        (answers[q._id]?.points ?? 0) > 0
                                                            ? '#1b5e20'
                                                            : (answers[q._id]?.points ?? 0) < 0
                                                                ? '#b71c1c'
                                                                : '#424242',
                                                }}>
                                                    {answers[q._id]?.points ?? 0}
                                                </div>
                                            </TableCell>

                                        </ TableRow>
                                    ))}
                                </TableBody>

                            </Table>
                        </TableContainer>

                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ my: 3 }}>
                            <Typography variant="subtitle1">
                                Pontuação total: <strong>{totalPoints}</strong>
                            </Typography>

                            <Chip
                                label={classification.label}
                                color={classification.color}
                                sx={{ fontWeight: 'bold', px: 1 }}
                            />
                        </Box>

                        <Box mt={2} fontSize={13} color="text.secondary">
                            <TableContainer>
                                <Table size="small">
                                    <TableHead>
                                        <TableRow sx={{ backgroundColor: '#f5f5f5' }}><TableContainer>
                                            <Table size="small">

                                                <TableHead>
                                                    <TableRow sx={{ backgroundColor: '#e0e0e0' }}>
                                                        <TableCell colSpan={2} align="center">
                                                            <strong>LENDA</strong>
                                                        </TableCell>
                                                    </TableRow>

                                                    <TableRow sx={{ backgroundColor: '#f5f5f5' }}>
                                                        <TableCell align="center"><strong>Pontuação</strong></TableCell>
                                                        <TableCell><strong>Tipo de Reacção</strong></TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                    <TableRow>
                                                        <TableCell align="center"><strong>≥ 9</strong></TableCell>
                                                        <TableCell>Definida (provada)</TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell align="center"><strong>5 - 8</strong></TableCell>
                                                        <TableCell>Provável</TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell align="center"><strong>1 - 4</strong></TableCell>
                                                        <TableCell>Possível</TableCell>
                                                    </TableRow>

                                                    <TableRow>
                                                        <TableCell align="center"><strong>≤ 0</strong></TableCell>
                                                        <TableCell>Duvidosa</TableCell>
                                                    </TableRow>
                                                </TableBody>

                                            </Table>
                                        </TableContainer>
                                        </TableRow>
                                    </TableHead>
                                </Table>
                            </TableContainer>
                        </Box>
                    </div>

                    {/* <Box m>
                        <FazerObservacoes setObs={setObs} obs={obs} titulo={''} />
                    </Box> */}

                    <ButtonLeft
                        title={'Salvar'}
                        funcao={handleSubmitCausalidade}
                        load={open}
                    >
                        <Button onClick={() => { setOpenModal(false); setAnswers({}); }} color="warning" size="small" style={{ marginTop: 20, marginRight: 10 }}>Cancelar</Button>
                    </ButtonLeft>

                </Card>
            </Modal>
        </>
    )
}